(() => {
  if (!document.body.classList.contains('mbm-template-product')) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  const observed = new WeakSet();
  const observers = new Set();
  const visible = element => element && element.getClientRects().length > 0;
  const purchase = () => [...document.querySelectorAll('.product__info-container,.ecom-product-form--single')].find(visible);
  function choose(info, name, focus = false) {
    const tabs = [...info.querySelectorAll('[data-mbm-tab]')];
    const selected = tabs.find(tab => tab.dataset.mbmTab === name);
    if (!selected) return;
    tabs.forEach(tab => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });
    info.querySelectorAll('[data-mbm-panel]').forEach(panel => { panel.hidden = panel.dataset.mbmPanel !== name; });
    if (focus) selected.focus({ preventScroll: true });
  }
  function followHash() {
    const id = window.location.hash.slice(1);
    const panel = document.getElementById(id);
    if (panel?.matches('[data-mbm-panel]')) choose(panel.closest('[data-mbm-product-info]'), panel.dataset.mbmPanel);
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-mbm-product-info]').forEach(info => {
      if (initialized.has(info)) return;
      initialized.add(info);
      const nav = info.querySelector('[data-mbm-tabs]');
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-orientation', 'horizontal');
      info.querySelectorAll('[data-mbm-tab]').forEach(tab => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.getAttribute('href').slice(1));
      });
      info.querySelectorAll('[data-mbm-panel]').forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('tabindex', '0'); });
      info.classList.add('is-enhanced');
      choose(info, 'details');
    });
    followHash();
    const card = purchase();
    const bar = document.querySelector('[data-mbm-product-jump]');
    if (!card || !bar || observed.has(card) || !('IntersectionObserver' in window)) return;
    observed.add(card);
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
    }), { threshold: 0 });
    observer.observe(card);
    observers.add(observer);
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-mbm-tab]');
    if (tab) {
      event.preventDefault();
      choose(tab.closest('[data-mbm-product-info]'), tab.dataset.mbmTab);
      return;
    }
    const link = event.target.closest('[data-mbm-open-tab]');
    if (link) {
      const panel = document.getElementById(link.getAttribute('href').slice(1));
      if (!panel) return;
      event.preventDefault();
      const info = panel.closest('[data-mbm-product-info]');
      choose(info, link.dataset.mbmOpenTab);
      info.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
      panel.focus({ preventScroll: true });
      return;
    }
    if (!event.target.closest('[data-mbm-jump-to-order]')) return;
    const card = purchase();
    const target = card?.querySelector('variant-selects,.product-form__input,.ecom-product-single__picker-wrapper') || card;
    if (!target) return;
    target.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'center' });
    const control = target.querySelector('input:not([type="hidden"]):not([disabled]),select:not([disabled]),button:not([disabled])');
    if (control) control.focus({ preventScroll: true });
    else { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-mbm-tab]');
    if (tab && event.key === ' ') { event.preventDefault(); tab.click(); return; }
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const info = tab.closest('[data-mbm-product-info]');
    const tabs = [...info.querySelectorAll('[data-mbm-tab]')];
    const index = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowLeft' ? 1 : -1) + tabs.length) % tabs.length;
    choose(info, tabs[next].dataset.mbmTab, true);
  });
  window.addEventListener('hashchange', followHash);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => { observers.forEach(observer => observer.disconnect()); observers.clear(); document.querySelectorAll('.product__info-container,.ecom-product-form--single').forEach(card => observed.delete(card)); });
  initialize();
})();
